/*
 * File: Routes.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: The routes used in the patient area
 */
import PatientHome from "./patient_home/PatientHome";
import PatientInformationPage from "./demographics/patient_info/pages/PatientInformationPage";
import PatientDemographics from "./demographics/DemographicsPage";
import Balances from "./demographics/balances/Balances";
import PatientAlerts from "./alerts";
import FeeSchedules from "./demographics/provider_office_fee/FeeSchedules";
import EmergencyContactPage from "./demographics/emergency_contact/EmergencyContactPage";
import Post_Charges from "./post_charges/Post_Charges";
import Appointments from "./appointments/Appointments";
import ClinicalApp from "./clinical/ClinicalApp";
import Referrals from "./referrals/Referrals";
import ReferralPage from "./referrals/ReferralPage";
import InsuranceAndGuarantorsPage from "./insurance_and_guarantors/InsuranceAndGuarantorsPage";

import Insurance from "./insurance_and_guarantors/insurance/Insurance";
import Guarantors from "./insurance_and_guarantors/guarantors/Guarantors";
import AllAppointments from "./appointments/AllAppointments";
import FollowUps from "./appointments/FollowUps";
import AppointmentPage from "../appointments/pages/AppointmentPage";

const Routes = [
  {
    path: "/patients/:patientId/insurance_and_guarantors",
    component: InsuranceAndGuarantorsPage,
    exact: true
  },
  {
    path: "/patients/:patientId/clinical",
    component: ClinicalApp
  },
  {
    path: "/patients/:patientId/appointments",
    component: Appointments,
    exact: true
  },
  {
    path: "/patients/:patientId/referrals",
    component: Referrals,
    exact: true
  },
  {
    path: "/patients/:patientId/referrals/:referralId",
    component: ReferralPage,
    exact: true
  },
  {
    path: "/patients/:patientId/new_charge",
    component: Post_Charges
  },
  {
    path: "/patients/:patientId/patient_home",
    component: PatientHome
  },
  {
    path: "/patients/:patientId/demographics",
    component: PatientDemographics,
    exact: true
  },
  {
    path: "/patients/:patientId/demographics/patient_information",
    component: PatientInformationPage
  },
  {
    path: "/patients/:patientId/demographics/balances",
    component: Balances
  },
  {
    path: "/patients/:patientId/demographics/alerts",
    component: PatientAlerts
  },
  {
    path: "/patients/:patientId/demographics/provider_office_fee",
    component: FeeSchedules
  },
  {
    path: "/patients/:patientId/demographics/emergency_contact",
    component: EmergencyContactPage
  },
  {
    path: "/patients/:patientId/insurance_and_guarantors/insurance",
    component: Insurance
  },
  {
    path: "/patients/:patientId/insurance_and_guarantors/guarantors",
    component: Guarantors
  },
  {
    path: "/patients/:patientId/appointments/patient_appointments",
    component: AllAppointments
  },
  {
    path: "/patients/:patientId/appointments/follow-ups",
    component: FollowUps
  },
  {
    path:
      "/patients/:patientId/appointments/appointment_details/:appointmentId",
    component: AppointmentPage
  }
];

export default Routes;
